export default __webpack_public_path__ + "static/media/globe.42644f45.png";